/**  A function that returns sorted, non-overlapping ranges that match words in the query */
export default function determineHighlightRanges(fullText: string, query: string): [number, number][] {
	// Initialize
	const specialChars = /[.*+?^${}()|[\]\\]/g;
	const wordsFromQuery = query.trim().split(/\s+/).filter(Boolean);
	const lowercaseText = fullText.toLowerCase();
	
	
	// Return early
	if (wordsFromQuery.length === 0) {
		return [];
	}
	
	
	// Initialize
	const ranges: [number, number][] = [];
	
	
	// Iterate over words in query
	for (const word of wordsFromQuery) {
		// Initialize
		const escapedWord = word.replace(specialChars, '\\$&').toLowerCase();
		
		
		// Return early
		if (!escapedWord) {
			continue;
		}
		
		
		// Initialize
		const regex = new RegExp(`\\b${escapedWord}`, 'gi');
		const match = regex.exec(lowercaseText);
		
		
		// Return early
		if (!match) {
			continue;
		}
		
		
		// Add first match positions
		ranges.push([match.index, match.index + match[0].length]);
		
		
		// Handle multi word queries
		//  -> When query is a single word, only the first match is returned
		if (wordsFromQuery.length > 1) {
			let next: RegExpExecArray | null;
			
			while ((next = regex.exec(lowercaseText)) !== null) {
				ranges.push([next.index, next.index + next[0].length]);
			}
		}
	}
	
	
	// Sort
	ranges.sort((a, b) => a[0] - b[0]);
	
	
	// Initialize
	const merged: [number, number][] = [];
	
	
	// Merge overlapping ranges
	//  -> Avoids double highlighting
	for (const range of ranges) {
		const last = merged[merged.length - 1];
		
		if (last && range[0] <= last[1]) {
			last[1] = Math.max(last[1], range[1]);
		} else {
			merged.push([...range]);
		}
	}
	
	
	// Return
	return merged;
}
